import httpClient from "@lab/api/httpClient";
import { ListingBulkEdit } from "@/shared/types/bulkedits";
import { Listing } from "@/shared/types/listings";

const update = async (id: number, path: string, options: ListingBulkEdit[]) => {
	const response = await httpClient.post(
		`/organisations/${id}/listingsedit/${path}`,
		options
	);
	return response.data;
};

const updateList = async (id: number, listings: Listing[]) => {
	const response = await httpClient.put(
		`/organisations/${id}/listings`,
		listings
	);
	return response.data;
};

export { update, updateList };
